import { ArrowUpRight } from "lucide-react";
import { waLink } from "../../lib/brand";

const items = [
  {
    id: "anklets",
    title: "Silver Anklets",
    sub: "Payal",
    img: "https://images.pexels.com/photos/33287642/pexels-photo-33287642.jpeg",
    size: "lg:col-span-5 lg:row-span-2",
    tall: true,
  },
  {
    id: "rings",
    title: "Silver Rings",
    sub: "Everyday & Occasion",
    img: "https://images.pexels.com/photos/20306795/pexels-photo-20306795.jpeg",
    size: "lg:col-span-4",
  },
  {
    id: "bracelets",
    title: "Silver Bracelets",
    sub: "Kada & Cuffs",
    img: "https://images.unsplash.com/photo-1767786124293-289dafe6340d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    size: "lg:col-span-3",
  },
  {
    id: "neckpieces",
    title: "Silver Neckpieces",
    sub: "Haar & Pendants",
    img: "https://images.pexels.com/photos/16109307/pexels-photo-16109307.jpeg",
    size: "lg:col-span-4",
  },
  {
    id: "traditional",
    title: "Traditional Ornaments",
    sub: "Temple & Heirloom",
    img: "https://images.pexels.com/photos/33834689/pexels-photo-33834689.jpeg",
    size: "lg:col-span-3",
  },
];

export const Collections = () => {
  return (
    <section
      id="collections"
      data-testid="collections-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl reveal">
            <p className="text-[11px] tracking-[0.4em] uppercase text-zinc-500 mb-5">
              01 — Silver Collections
            </p>
            <h2 className="font-display font-light text-zinc-950 text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Crafted in silver,
              <br />
              <span className="italic text-zinc-600">worn for a lifetime.</span>
            </h2>
          </div>
          <p className="lg:max-w-sm text-zinc-600 leading-relaxed reveal reveal-delay-1">
            Every piece is shaped from 92.5 sterling silver and finished by hand
            in our Chandni Chowk workshop. Explore five quiet categories we are
            known for.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 lg:gap-6 auto-rows-[280px] lg:auto-rows-[260px]">
          {items.map((it, i) => (
            <a
              key={it.id}
              href={waLink(`Hi, I'd like to see designs in ${it.title}.`)}
              target="_blank"
              rel="noreferrer"
              data-testid={`collection-${it.id}`}
              className={`group relative overflow-hidden bg-zinc-100 border border-zinc-200 img-zoom-wrap reveal reveal-delay-${
                (i % 4) + 1
              } ${it.size}`}
            >
              <img
                src={it.img}
                alt={it.title}
                className="absolute inset-0 h-full w-full object-cover img-zoom"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
              <div className="absolute inset-0 p-6 lg:p-8 flex flex-col justify-end">
                <p className="text-[10px] tracking-[0.35em] uppercase text-zinc-200/90">
                  {it.sub}
                </p>
                <div className="mt-2 flex items-end justify-between gap-4">
                  <h3 className="font-display text-2xl lg:text-3xl text-white leading-tight">
                    {it.title}
                  </h3>
                  <span className="shrink-0 h-10 w-10 grid place-items-center border border-white/70 text-white group-hover:bg-white group-hover:text-zinc-950 transition-colors">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>
                <span className="mt-4 text-[10px] tracking-[0.3em] uppercase text-white/80">
                  View Designs
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
